import { render, staticRenderFns } from "./serveProjectDialog.vue?vue&type=template&id=34112454&scoped=true&"
import script from "./serveProjectDialog.vue?vue&type=script&lang=js&"
export * from "./serveProjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./serveProjectDialog.vue?vue&type=style&index=0&id=34112454&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34112454",
  null
  
)

export default component.exports